class BaseButton {
    buttonContainer = new THREE.Object3D();
    dimension;
    scale = new THREE.Vector3(1.5, .75, .75);
    position = new THREE.Vector3(-1.1, -2, 0);
    text;
    fontFamily;
    fontSize;
    isIconButton;
    iconSource;
    callback = undefined;
    isVisible;
    mesh;
    id;
    name;
    yAxisForRotation;
    delta;

    constructor(params) {
        this.setParent(params.parent);
        this.name = params.name;
        this.text = params.text;
        this.fontFamily = params.fontFamily || global_font_family;
        this.fontSize = params.fontSize || "60px";
        this.textColor = params.textColor || "#ffffff";
        this.backgroundColor = params.backgroundColor || "#1793e6";
        this.iconSource = params.iconSource || 'icons/list.png';
        this.isSprite = params.isSprite || false;
        this.isIconButton = params.isIconButton || false;
        this.isVisible = params.isVisible !== undefined ? params.isVisible : true;
        this.position = params.position || new THREE.Vector3();
        this.scale = params.scale || new THREE.Quaternion();
        this.buttonContainer.buttonID = generateUUID();
        this.createMesh();
        this.setMesh();
        this.setLocationAndScaling();
    }

    setDeltaAndYAxisOfRotation(yAxisForRotation, leftRightRotationDelta) {
        this.yAxisForRotation = yAxisForRotation;
        if (!this.delta) {
            this.delta = leftRightRotationDelta;
        } else {
            this.delta += leftRightRotationDelta;
        }

    }

    modifyScale(standardScale) {
        if (isMobileARModeEnabled()) {
            const standardPixelX = Object.keys(standardScale.width)[0];
            const standardWidthX = Object.values(standardScale.width)[0];

            const standardPixelY = Object.keys(standardScale.height)[0];
            const standardHeightY = Object.values(standardScale.height)[0];

            const scaleX = (window.innerWidth * standardWidthX) / standardPixelX;
            const scaleY = (window.innerWidth * standardHeightY) / standardPixelY;

            this.scale.x = scaleX;
            this.scale.y = scaleY;
        }
    }

    getDeltaAndYAxisOfRotation() {
        return {delta: this.delta, yAxisForRotation: this.yAxisForRotation};
    }

    setLocationAndDimension(location, dimension) {
        const {scale, position} = mapScreenDimensionTo3D(location, dimension);
        this.position = position;
        this.scale = scale;
        this.setLocationAndScaling();
    }

    setLocationAndScaling() {
        this.buttonContainer.scale.copy(this.scale);
        this.buttonContainer.position.copy(this.position);
    }

    createMesh() {
        if (this.isIconButton) {
            this.createIconButtonMesh();
        } else {
            this.createTextButtonMesh();
        }

        this.updateVisibility();
    }

    createIconButtonMesh() {
        const textureLoader = new THREE.TextureLoader();
        const imageTexture = textureLoader.load(this.iconSource);
        const material = this.isSprite ? new THREE.SpriteMaterial({
            map: imageTexture,
            opacity: 0.99,
            transparent: true,
            alphaTest: 0.5,
            side: THREE.doubleSided,
            depthWrite: true,
        }) : new THREE.MeshBasicMaterial({
            map: imageTexture,
            transparent: true,
            alphaTest: 0.5,
            side: THREE.doubleSided
        });

        this.mesh = this.isSprite ? new THREE.Sprite(material) : new THREE.Mesh(new THREE.PlaneGeometry(1, 1), material);
    }

    createTextButtonMesh() {
        const menuPicture = new Picture2D.Picture(new Picture2D.Overlapped(
            new Picture2D.SolidRect(this.backgroundColor),
            new Picture2D.Text(this.text, this.fontSize + " " + this.fontFamily, this.textColor)
        ), 256, 256);
        menuPicture.paint();
        const menuTexture = new THREE.CanvasTexture(menuPicture.canvas);
        menuTexture.colorSpace = THREE.SRGBColorSpace;

        const menuMaterial = this.isSprite ? new THREE.SpriteMaterial({
            map: menuTexture,
            opacity: 0.99,
            transparent: true,
            alphaTest: 0.5,
            side: THREE.doubleSided,
            depthWrite: true,
        }) : new THREE.MeshBasicMaterial({
            map: menuTexture,
            opacity: 0.99,
            transparent: true,
            alphaTest: 0.5,
            side: THREE.doubleSided,
            depthWrite: true,
        });

        this.mesh = this.isSprite ? new THREE.Sprite(menuMaterial) : new THREE.Mesh(new THREE.PlaneGeometry(1, 1), menuMaterial);
    }

    onVRModeChange() {
    }

    setMesh() {
        this.buttonContainer.add(this.mesh);
    }

    setVisibility(visibility) {
        this.isVisible = visibility;
        this.updateVisibility();
    }

    updateVisibility() {
        this.buttonContainer.visible = this.isVisible;
    }

    setCallback(callback) {
        this.callback = callback;
    }

    setParent(parent) {
        parent.add(this.buttonContainer);
    }

    updateZAxisPosition(value) {
        this.buttonContainer.position.z = value;
    }

    updateMenuRotationBasedPosition(rotationCenter) {
        const menuObject = mController.menuDataView.getMenuObject();

        if (!this.yAxisForRotation || !this.delta) {
            return;
        }

        const applyMatrix = getRotationTranslationMatrix(rotationCenter, this.yAxisForRotation, this.delta, menuObject);
        menuObject.applyMatrix4(applyMatrix);
        menuObject.updateMatrixWorld(true);
        menu_global_parent_position.scene.position.copy(menuObject.position);
        menu_global_parent_position.scene.scale.copy(menuObject.scale);
    }

}

export default BaseButton;